<template>
  <!-- MODAL Link Bundle -->
  <div id="textAlertModal" class="col-12 justify-content-center" style="padding: 15vh 30%">
    <div class="col-12 m-0 p-0 section-container rounded-5 bg-caja shadow modal-lg">
      <div class="row overflow-hidden col-12 m-0 p-0 text-white rounded-top-5 pb-1 h-100 bg-lat1">
        <div class="col-10">
          <h6 class="lh-1 tx-left tx-white mb-2 ps-1 pt-2">
            <ion-icon :name="(linkAction === 'link') ? 'log-in-outline' : 'log-out-outline'"
              class="tx-18 me-2 align-bottom"></ion-icon>
            {{ ((linkAction === 'link')
              ? dictionary['Vincular'][session.user.language] : dictionary['Desvincular'][session.user.language])+ " "+ this.targetBundleData.label}}
          </h6>
        </div>
        <div class="col-2 m-0 p-0 d-flex justify-content-end btn" @click="this.$emit('dismissAlert')">
          <ion-icon name="close" class="ms-auto tx-30 pt-1 pe-1 tx-white align-bottom"></ion-icon>
        </div>
      </div>

      <div class="form-group col-12 p-0 pe-3 text-white" style="background-color: #03103e;">
        <div id="linkBundleScroll" class="col-12 p-3" style="overflow: auto; overflow-x: hidden; max-height: 60vh;">
          <div class="row col-12 border border rounded m-0 p-1 pb-0">
            <div class="col-lg-12 col-12">
              <div class="col-12 m-0 p-2 d-flex flex-column tx-left">
                <span class="col-12 m-0 p-0 tx-bold tx-14">
                  {{ (dictionary[(this.$route.params.currentDisplay === 'machines') ? "Máquina" : "Centro de mando"][session.user.language])+": "}}
                </span>
                <span class="col-12 m-0 p-0 tx-12">
                  {{ targetBundleId }}
                </span>
              </div>

              <div v-if="linkAction === 'link'" class="col-12 m-0 p-2 d-flex flex-column tx-left">
                <span class="col-12 m-0 p-0 tx-bold tx-14">
                  {{ dictionary['Tipo'][session.user.language] + ": " }}
                </span>
                <select class="col-12 m-0 p-0 form-control p-2 h-100 bg-white d-flex" style="color:black;"
                  v-model="parentType" @change="onChangeParentType">
                  <option v-if="this.$route.params.currentModule === 'fabric'
                    || this.$route.params.currentModule === 'smartLockers'
                    || this.$route.params.currentModule === 'electricalMonitoring'" value="machine">
                    {{ dictionary[(this.$route.params.currentDisplay === 'machines') ? "Máquina" : "Centro de mando"][session.user.language]}}
                  </option>
                  <option v-if="this.$route.params.currentModule === 'devices'
                    || this.$route.params.currentModule === 'fabric'
                    || this.$route.params.currentModule === 'storage'
                    || this.$route.params.currentModule === 'smartLockers'
                    || this.$route.params.currentModule === 'electricalMonitoring'" value="emplacement">
                    {{ dictionary['Emplazamiento'][session.user.language] }}
                  </option>
                </select>

                <span v-if="parentType === 'emplacement'" class="col-12 m-0 p-0 tx-bold tx-14">
                  {{ dictionary['Emplazamiento'][session.user.language] + ": " }}
                </span>
                <input v-if="parentType === 'emplacement'" type="text" v-model="searchQuery" placeholder="Buscar"
                  class="form-control mt-2 mb-2 text-dark" />
                <select v-if="parentType === 'emplacement'" class="col-12 m-0 p-0 form-control p-2 h-100 bg-white d-flex"
                  style="color:black;" v-model="targetEntityId" @change="onTargetEntity">
                  <option v-for="emplacement in filteredEmplacements" :key="emplacement" :value="emplacement.id"
                    :selected="emplacement.id === targetEntityId">
                    {{ emplacement.label }}
                  </option>
                </select>

                <span v-if="parentType === 'machine'" class="col-12 m-0 p-0 tx-bold tx-14">
                  {{ dictionary['Máquina'][session.user.language] + ": " }}
                </span>
                <input v-if="parentType === 'machine'" type="text" v-model="searchQuery" placeholder="Buscar"
                  class="form-control mt-2 mb-2 text-dark" />
                <select v-if="parentType === 'machine'" class="col-12 m-0 p-0 form-control p-2 h-100 bg-white d-flex"
                  style="color:black;" v-model="targetEntityId" @change="onTargetEntity">
                  <option v-for="machine in filteredMachines" :key="machine" :value="machine.id"
                    :selected="machine.id === targetEntityId">
                    {{ machine.label }}
                  </option>
                </select>
              </div>
              
              <div class="col-lg-12 col-md-12 col-12 p-2 ps-1 pe-1">
                <!-- SUBMIT -->
                <button type="button" id="btnSubmitTargetBundle" class="button-ok bg-lat1 w-100"
                  @click="linkBundleToEntity">
                  {{ dictionary['Aceptar'][session.user.language] }}
                </button>
              </div>

              <div class="col-lg-12 col-md-12 col-12 p-2 ps-1 pe-1">
                <!-- DISMISS -->
                <button type="button" id="btnCancelTargetBundle" class="button-ok bg-lat1 w-100"
                  @click="this.$emit('dismissAlert')">
                  {{ dictionary['Cancelar'][session.user.language] }}
                </button>
              </div>
            </div>
            <div class="row m-0 p-2">
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>

// Clomos
import api from '@/services/api';

export default {
  name: "TargetBundleModal",
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    targetBundleId: {
      type: String,
      required: true,
    },
    linkAction: {
      type: String,
      required: true,
    },
    currentCompany: {
      type: Object,
      required: true,
    },
  },
  watch: {
    filteredBundles(newVal) {
      if (newVal.length > 0) {
        this.targetEntityId = newVal[0].id;
      }
    },
    filteredMachines(newVal) {
      if (newVal.length > 0) {
        this.targetEntityId = newVal[0].id;
      }
    },
    filteredEmplacements(newVal) {
      if (newVal.length > 0) {
        this.targetEntityId = newVal[0].id;
      }
    }
  },
  data() {
    return {
      targetBundleData: {},
      parentType: "emplacement",
      targetEntityId: "",
      targetEntity: {},
      availableEmplacements: [],
      availableBundles: [],
      availableMachines: [],
      newGeoJSON: {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [0, 0]
        }
      },
      machineMap: undefined,
      machineMarker: undefined,
      searchQuery: ""
    }
  },
  computed: {
     filteredBundles() {
      if (!Array.isArray(this.availableBundles) || this.availableBundles.length === 0) {
        return [];
      }
      return this.availableBundles.filter(machine => {
        const label = machine.label;
        return typeof label === 'string' && label
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "") 
          .includes(
            this.searchQuery
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          );
      });
    },
    filteredMachines() {
      if (!Array.isArray(this.availableMachines) || this.availableMachines.length === 0) {
        return [];
      }
      return this.availableMachines.filter(machine => {
        const label = machine.label;
        return typeof label === 'string' && label
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "") 
          .includes(
            this.searchQuery
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          );
      });
    },
    filteredEmplacements() {
      if (!Array.isArray(this.availableEmplacements) || this.availableEmplacements.length === 0) {
        return [];
      }
      return this.availableEmplacements.filter(emplacement => {
        const label = emplacement.label;
        return typeof label === 'string' && label
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "") 
          .includes(
            this.searchQuery
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          );
      });
    },
  },
  emits: ["dismissAlert"],
  methods: {
    // DISPLAY
    onChangeParentType() {
      this.targetEntity = {};
      this.searchQuery = '';
      if (this.parentType === 'machine') {
        this.getMachineList();
      }
      if (this.parentType === 'emplacement') {
        this.getEmplacementList();
      }
    },
    // GET
    async getTargetBundleData(callback) {
      let response = await api.getBundleData(this.targetBundleId);
      this.targetBundleData = api.parseBundleFromResponse(response);
      if (callback && typeof callback === "function") callback(this.targetBundleData);
    },
    async getBundleList(callback) {
      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };
      let response = await api.getBundleListByCompany(request);
      let allAvailableBundles = api.parseBundlesFromResponse(response);
      this.availableBundles = [];
      for (let i in allAvailableBundles) {
        if (allAvailableBundles[i].id != this.targetBundleId) this.availableBundles.push(allAvailableBundles[i])
      }
      if (this.availableBundles[0] != undefined) {
        this.targetEntityId = this.availableBundles[0].id;
        this.targetEntity = this.availableBundles[0];
      }
      if (callback && typeof callback === "function") callback(this.availableBundles);
    },
    async getEmplacementList(callback) {
      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };
      let response = await api.getEmplacementList(request);
      this.availableEmplacements = api.parseEmplacementsFromResponse(response);
      if (this.availableEmplacements[0] != undefined) {
        this.targetEntityId = this.availableEmplacements[0].id;
        this.targetEntity = this.availableEmplacements[0];
      } if (callback && typeof callback === "function") callback(this.availableEmplacements);
    },
    async getMachineList(callback) {
      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };
      let response = await api.getMachineListByCompany(request);
      this.availableMachines = api.parseMachinesFromResponse(response);
      if (this.availableMachines[0] != undefined) {
        this.targetEntityId = this.availableMachines[0].id;
        this.targetEntity = this.availableMachines[0];
      } if (callback && typeof callback === "function") callback(this.availableMachines);
    },
    // TARGET
    onTargetEntity(event) {
      this.targetEntityId = event.target.value;
      if (this.parentType === 'machine') for (let i in this.availableMachines) {
        if (this.availableMachines[i].id === this.targetEntityId)
        this.targetEntity = this.availableMachines[i];
      }
      else if (this.parentType === 'emplacement') for (let i in this.emplacementList) {
        if (this.emplacementList[i].id === this.targetEntityId)
          this.targetEntity = this.emplacementList[i];
      }
    },
    // SET 
    async linkBundleToEntity(callback) {
      let response = {};
      let request = {
        bundleId: this.targetBundleId,
        parentId: this.targetEntityId,
        geoJSON: this.newGeoJSON
      }
      if (this.parentType === 'machine') {
        response = await api.setBundleParentAsMachine(request);
      }
      else if (this.parentType === 'emplacement') {
        response = await api.setBundleParentAsEmplacement(request);
      }
      if (response["status-code"] === "200") this.$emit('dismissAlert');
      if (callback && typeof callback === "function") callback(this.availableMachines);
    }
  },
  async created() {
    await this.getTargetBundleData();
    if (this.linkAction === "link") {
      this.onChangeParentType();
      if (this.availableMachines[0] != undefined)
        this.targetEntityId = this.availableMachines[0].id;
    }
    else {
      this.targetEntityId = "";
    }
  }
}
</script>

<style>
#textAlertModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
}
</style>